import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=3f4e0542&"
import script from "./Certificate.vue?vue&type=script&lang=ts&"
export * from "./Certificate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports